jQuery(document).ready(function($) {
  $.fn.select2.defaults.set('language', 'pt-BR')

  $('.select2').each(function(index, el) {
    $(el)
      .parent()
      .hide()

    $(el).select2({
      width: 'resolve',
      minimumResultsForSearch: $(window).width() >= 780 ? 7 : 9999999,
      allowClear: $(el).attr('data-clear')
    })
    if ($(el).attr('data-value')) $(el).select2('trigger', 'select', { data: { id: $(el).attr('data-value') } })

    $(el)
      .parent()
      .show()
  })

  window.createSelect2Load = function(el, myvalue = '') {
    $(el).html('<option value="">Anunciante</option>')
    $(el).select2({
      allowClear: $(el).attr('data-clear'),
      placeholder: $(el).attr('data-placeholder'),
      minimumResultsForSearch: $(window).width() >= 780 ? 20 : 9999999
    })

    $(el)
      .parent()
      .hide()
    $.ajax({
      url: el.getAttribute('data-href')
    }).done(function(data) {
      $(el).select2({
        data: data,
        placeholder: $(el).attr('data-placeholder'),
        allowClear: $(el).attr('data-clear'),
        minimumResultsForSearch: $(window).width() >= 780 ? 20 : 9999999
      })
      if ($(el).attr('data-value') && $(el).attr('data-value') != '')
        $(el).select2('trigger', 'select', { data: { id: $(el).attr('data-value') } })

      $(el).val(myvalue)

      $(el)
        .parent()
        .show()
    })
  }

  if ($('.select2-load')[0]) {
    $('.select2-load').each(function(index, el) {
      createSelect2Load(el)
    })
  }
  if ($('.select2-change')[0]) {
    $('.select2-change').each(function(index, el) {
      $(el).select2({
        placeholder: el.getAttribute('data-placeholder')
      })

      setTimeout(function() {
        window.bairro = 1

        let placeholder = $('.form-field-bairro .select2-search__field').attr('placeholder')
        if (!placeholder) $('.form-field-bairro .select2-search__field').attr('placeholder', 'Pesquise mais bairros...')

        placeholder = $('.form-field-tipo .select2-search__field').attr('placeholder')
        if (!placeholder) $('.form-field-tipo .select2-search__field').attr('placeholder', 'Pesquise mais tipos...')

        placeholder = $('.form-field-operacao .select2-search__field').attr('placeholder')
        if (!placeholder) $('.form-field-operacao .select2-search__field').attr('placeholder', 'Pesquise mais tipos...')
      }, 300)

      $(el.getAttribute('data-change')).change(function(event) {
        $(el)
          .html('')
          .select2({ data: [] })

        if ($(el.getAttribute('data-change')).val() != '') {
          $.ajax({
            url: el.getAttribute('data-href'),
            data: { cidade: $(el.getAttribute('data-change')).val() }
          }).done(function(data) {
            $(el).select2({ data: data, minimumResultsForSearch: $(window).width() >= 780 ? 20 : 9999999 })
            if ($(el).attr('data-value')) {
              $(el)
                .parent()
                .find('.select2-search--inline .select2-search__field')
                .hide()

              if ($(el).attr('multiple')) {
                $(el)
                  .attr('data-value')
                  .split(',')
                  .forEach(function(data) {
                    $(el).select2('trigger', 'select', { data: { id: data } })
                  })
              } else $(el).select2('trigger', 'select', { data: { id: $(el).attr('data-value') } })

              $(el).attr('data-value', '')

              if ($(el).attr('id') == 'busca-bairro') {
                window.bairro = 1
                setTimeout(function() {
                  window.bairro = 1
                }, 300)
              }
            } else if ($(el).attr('id') == 'busca-bairro') {
              setTimeout(function() {
                window.bairro = 1
              }, 300)
            }
            // $('#header').focus();
            $(el)
              .parent()
              .find('.select2-search--inline .select2-search__field')
              .show()

            if ($(el).attr('id') == 'busca-bairro')
              $(el)
                .parent()
                .show()
          })
        }
        // $(el).select2('trigger', "select", { data: { id: $(el).attr('data-value') }});
      })
    })
  }

  var createSelect2Busca = function(el, data) {
    $(el).select2({
      placeholder: 'Insira o bairro ou cidade',
      language: 'pt-BR',
      data: data
      // ajax: {
      //     url: $(el).attr('data-href'),
      //     dataType: 'json',
      // 	delay: 250,
      //     data: function (params) {
      //       return {
      //         q: params.term
      //       };
      //     },
      //     processResults: function (data, params) {
      //       return {
      //         results: data
      //       };
      //     },

      //     escapeMarkup: function (markup) { return markup; }, // let our custom formatter work
      //     cache: true
      //  	},
    })
  }

  $('.select2-busca').each(function(index, el) {
    createSelect2Busca(el, [])

    $.ajax($(el).attr('data-href'), {
      dataType: 'json',
      data: {
        cidade: $(el).attr('data-value')
      }
    }).done(function(data) {
      createSelect2Busca(el, data)

      if ($(el).attr('data-value')) $(el).select2('trigger', 'select', { data: { id: $(el).attr('data-value') } })
    })
  })
})
